import toastr from './toastOption';

/* eslint-env browser */
/* global google */
require('jquery');
require('bootstrap');

$(window).on('DOMContentLoaded', () => {
  const query = new URLSearchParams(window.location.search);
  if (query.has('page')) {
    const merchantMenu = $('#suppliersMenuTabContent');
    $('html, body').animate({
      scrollTop: merchantMenu.offset().top - 20,
    });
  }
});

((window, document) => {
  class FilterList {
    constructor(name) {
      this.name = name;
      this.filterItems = Array.prototype.slice.call(document.getElementsByClassName(`${name}-filter-item`));
      this.allItemsToggle = document.getElementById(`${name}-all-toggle`);
      this.categoriesSections = {};
      this.allChecked = true;
    }

    init() {
      this.filterItems.forEach((item) => {
        item.addEventListener('change', this.onFilterChangeHandler.bind(this));
      });
      this.allItemsToggle.addEventListener('change', this.onAllFiltersChangeHandler.bind(this));
    }

    onAllFiltersChangeHandler(event) {
      event.stopPropagation();
      if (!event.target.checked) {
        event.preventDefault();
        return;
      }
      this.handleAllChecked();
    }

    onFilterChangeHandler(event) {
      event.stopPropagation();

      // Check if all items are checked or unchecked
      if (this.filterItems.every(item => (item.checked === event.target.checked))) {
        this.allChecked = true;
        return this.handleAllChecked();
      }
      this.allItemsToggle.checked = false;
      return true;
    }

    getCategorySection(id) {
      if (!this.categoriesSections[id]) {
        this.categoriesSections[id] = document.getElementById(`category-${id}-items`);
      }
    }

    handleAllChecked() {
      this.allItemsToggle.checked = true;

      this.filterItems.forEach((item) => {
        item.checked = false; // eslint-disable-line no-param-reassign
      });
    }
  }

  class MerchantMap {
    constructor() {
      this.container = document.getElementById('merchant-map');
      if (!this.container) {
        throw new Error('Cannot find container for Google Map');
      }

      this.coordinates = {
        lng: parseFloat(document.getElementById('merchant_map_longtitude').value),
        lat: parseFloat(document.getElementById('merchant_map_latitude').value),
      };
      this.map = null;
      this.mapMerker = null;

      this.merchantData = {
        name: '',
        address: '',
        logo: '',
        rating: 0,
      };
    }

    init() {
      this.map = new google.maps.Map(this.container, {
        disableDefaultUI: true,
      });

      const bounds = new google.maps.LatLngBounds();
      const marker = new google.maps.Marker({
        position: { lat: this.coordinates.lat, lng: this.coordinates.lng },
        map: this.map,
      });
      bounds.extend(marker.getPosition());
      this.map.setCenter(bounds.getCenter());
      this.map.fitBounds(bounds);
      setTimeout(() => {
        this.map.panBy(-400, 0);
      }, 1000);


      const listener = google.maps.event.addListener(this.map, 'idle', () => {
        this.map.setZoom(15);
        google.maps.event.removeListener(listener);
      });
    }
  }

  class MerchantMenuController {
    constructor() {
      this.filters = [];
      this.map = null;
    }

    init() {
      // If we are on the right page
      if ($('#productMenu').length > 0) {
        this.filters.push(new FilterList('kind'));
        this.filters.push(new FilterList('price'));
      }

      $('#filter-section ul').each(function expandList() {
        const ullist = $(this);
        const hiddenlist = ullist.find('li:gt(4)');
        let isExpanded = ullist.hasClass('expanded');
        hiddenlist[isExpanded ? 'show' : 'hide']();

        const morelink = `${'<li>' +
          '<div class="checkbox-item">' +
          '<a href="#" class="show-filters-link" title="show more">Show '}${isExpanded ? 'less' : 'more'}</a>` +
          '</div>' +
          '</li>';

        if (hiddenlist.length > 0) {
          ullist
            .append($(morelink)
              .click(function processExpand(event) {
                isExpanded = ullist.hasClass('expanded');
                event.preventDefault();
                $(this).find('a').text(isExpanded ? 'Show more' : 'Show less');
                ullist.toggleClass('expanded');
                hiddenlist.slideToggle('fast');
                hiddenlist.attr('style', !isExpanded ? '' : 'display: none !important;');
              }));
        }
      });

      const mapContainer = document.getElementById('merchant-map');
      if (mapContainer) {
        this.map = new MerchantMap();
        this.map.init();
      }

      const productItem = $('.product-item');

      productItem.on('click', '.add-product-link', (event) => {
        event.stopPropagation();
        event.preventDefault();

        $.ajax({
          url: `/store/product?id=${event.delegateTarget.dataset.product}&size=${event.currentTarget.dataset.size}`,
          type: 'GET',
          dataType: 'json',
          success: (data) => {
            if (data.status) {
              $('#product-modal-container').html(data.html);
              /* eslint-disable no-use-before-define */
              initProductPopup();
              $('#orderProduct').modal();
            }
          },
          error: (data) => {
            if (data.status === 400) {
              toastr.warning(data.responseJSON.message);
            }
          },
        });
      });

      productItem.on('click', (event) => {
        const { targetUrl } = event.currentTarget.dataset;
        const { website } = event.currentTarget.dataset;
        const { isPlaceOrder } = event.currentTarget.dataset;
        if (!isPlaceOrder) {
          let url = false;
          if (targetUrl) {
            url = targetUrl;
          } else if (website) {
            url = website;
          }
          if (url) {
            Object.assign(document.createElement('a'), { target: '_blank', href: url }).click();
          } else {
            // eslint-disable-next-line no-console
            console.log('Placing orders is prohibited, but there is no link to an external site');
          }
        }
      });

      this.filters.forEach(item => item.init());
    }
  }

  const merchantMenuController = new MerchantMenuController();
  merchantMenuController.init();

  $('#details-tab').on('shown.bs.tab', () => {
    const merchantAboutSection = $('#merchantAbout');
    const merchantAboutCollapseToggle = $('#merchantAboutCollapse');

    if (merchantAboutSection[0] && merchantAboutSection[0].clientHeight < 240) {
      merchantAboutCollapseToggle.addClass('d-none');
    } else {
      merchantAboutSection.addClass('added-collapse');
    }
  });

  $(document).on('click', 'a#details-tab', (e) => {
    e.preventDefault();
    const loc = window.location.href;

    const array = loc.split('/');
    array.pop();
    const newUrl = array.join('/');
    $('#details-nav-item').addClass('active');
    $('#productMenu-nav-item').removeClass('active');
    window.history.pushState(null, null, `${newUrl}/about`);
  });
  $(document).on('click', 'a#productMenu-tab', (e) => {
    e.preventDefault();
    const loc = window.location.href;

    const array = loc.split('/');
    array.pop();
    const newUrl = array.join('/');
    $('#details-nav-item').removeClass('active');
    $('#productMenu-nav-item').addClass('active');
    window.history.pushState(null, null, `${newUrl}/menu`);
  });

  function initProductPopup() {
    const $productSize = $('#product-modal-container #product-size');
    const $productCount = $('#product-modal-container #product-count');

    // $productSize.selectize();

    $productSize.on('change', function () {
      const price = parseInt($(this).val().split('|')[0], 10);
      $productCount.html('1');
      /* eslint-disable no-bitwise */
      $('#total-product-price').html(price * ($productCount.html() | 0));
    });

    $('#minus').on('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      let count = $productCount.html() | 0;
      if (count === 1) {
        return false;
      }

      // eslint-disable-next-line no-plusplus
      $productCount.html(--count);

      const price = parseInt($productSize.val().split('|')[0], 10);
      $('#total-product-price').html(price * count);
      return false;
    });

    $('#plus').on('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      let count = $productCount.html() | 0;
      // eslint-disable-next-line no-plusplus
      $productCount.html(++count);
      const price = parseInt($productSize.val().split('|')[0], 10);
      $('#total-product-price').html(price * count);
    });

    $('#add-product-to-cart').on('click', () => {
      const currentProductMerchantId = $('#current-product-merchant-id').val();
      const hasItemsAnotherMerchant = ($('#has-items-another-merchant').val() === 'true');
      let confirmation = true;
      if (hasItemsAnotherMerchant) {
        // eslint-disable-next-line no-restricted-globals,no-alert
        confirmation = confirm('At the moment, you can place an order for products from only one merchant. If you add this product, the other merchant\'s products will be removed from your cart. Continue?');
      }
      if (confirmation) {
        /* eslint-disable prefer-template */
        const data = [
          'action=addToCart',
          'currentController=store',
          'item_id=' + $('#current-product-id').val(),
          'merchant_id=' + currentProductMerchantId,
          'category_id=' + $('#current-product-category-id').val(),
          'qty=' + $('#product-count').html(),
          'price=' + $productSize.val(),
        ];
        $.ajax({
          type: 'POST',
          dataType: 'json',
          url: '/admin/ajax',
          data: data.join('&'),
          success: (response) => {
            if (response.code === 1) {
              window.location.reload();
            }
          },
        });
      } else {
        $('#orderProduct').modal('toggle');
      }
    });
  }
})(window, window.document);
